import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import basquet from "../assests/images/logo_suenos_basquet.jpg";
import voley from "../assests/images/logo_suenos_voley.jpg";
import Footer from "../components/Footer";

const Home = () => {
  const navigate = useNavigate();

  const handleClick = (path) => {
    navigate(path);
  };

  return (
    <Box>

    
      <Box
        sx={{
          minHeight: "70vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          p: 4,
        }}
      >

        <Grid container spacing={6} justifyContent="center">
          {/* 🏀 BASQUET */}
          <Grid item xs={12} sm={6} md={4}>
            <Box
              component="img"
              src={basquet}
              alt="Sueños Básquet"
              onClick={() => handleClick("/basquet")}
              sx={{
                width: "100%",
                maxWidth: 300,
                cursor: "pointer",
                borderRadius: 3,
                transition: "transform 0.3s, box-shadow 0.3s",
                boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                "&:hover": {
                  transform: "scale(1.08)",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
                },
              }}
            />
            <Typography variant="h6" sx={{ mt: 2, fontWeight: 500 }}>
              Torneo de Básquet
            </Typography>
          </Grid>

          {/* 🏐 VOLEY */}
          <Grid item xs={12} sm={6} md={4}>
            <Box
              component="img"
              src={voley}
              alt="Sueños Vóley"
              onClick={() => handleClick("/voley")}
              sx={{
                width: "100%",
                maxWidth: 300,
                cursor: "pointer",
                borderRadius: 3,
                transition: "transform 0.3s, box-shadow 0.3s",
                boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                "&:hover": {
                  transform: "scale(1.08)",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
                },
              }}
            />
            <Typography variant="h6" sx={{ mt: 2, fontWeight: 500 }}>
              Torneo de Vóley
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </Box>
  );
};

export default Home;
